import classnames from 'classnames';
import { formatBindingLabel, useInputBindings } from '@sorrem-client/ui/hooks';
import styles from './CarriedSlotHotkeyHint.module.scss';

interface CarriedSlotHotkeyHintProps {
    readonly className?: string;
    /** The carried slot waiting for an action slot; the hint hides while null. */
    readonly slotIndex: number | null;
}

/** The callout over the loadout while a carried slot waits for the player to pick its action slot. */
export function CarriedSlotHotkeyHint({ className, slotIndex }: CarriedSlotHotkeyHintProps): JSX.Element {
    const { bindings } = useInputBindings();
    const cancelKey = formatBindingLabel(bindings, 'open-menu');

    return (
        <p className={classnames(styles.carriedSlotHotkeyHint, slotIndex !== null && styles.visible, className)} role='status'>
            {slotIndex !== null && (
                <>
                    Click an action slot or press its key to link <strong>carried slot {slotIndex + 1}</strong> there.
                    {' '}Pick its current one to unlink it. {cancelKey} cancels.
                </>
            )}
        </p>
    );
}
